import { Box, Tab, Tabs } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import { useSearchDomains } from '../../hooks/useSearchDomains/useSearchDomains.ts';
import { SearchResultTabLabel } from '../SearchResultTabLabel/SearchResultTabLabel';
import { RouteId } from '~/routes/RouteId.ts';
import { SearchDomain } from '~/routes/Search/types/SearchDomain.ts';

export interface SearchResultTabsProps {
  domain: SearchDomain;
}

export const SearchResultTabs = ({ domain }: SearchResultTabsProps) => {
  const navigate = useNavigate();
  const { searchDomains } = useSearchDomains();

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={domain}>
        {searchDomains.map((searchDomain) => {
          const domainUrl = RouteId.searchDetail(searchDomain);
          return (
            <Tab
              key={searchDomain}
              value={searchDomain}
              label={<SearchResultTabLabel domain={searchDomain} />}
              to={domainUrl}
              component={Link}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                // we don't want to re-render all the time when updating the search state
                // therefore we are using the navigate function
                // to append the search query parameters at time of the click
                navigate(`${domainUrl}${window.location.search}`);
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
